import * as React from 'react';
import urljoin from 'url-join';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { IRootState } from '../../domain/index';
import { getRoute } from '../../domain/Ui/UiHelpers';
import StatusMessage from '../legos/StatusMessage';
import { routes } from '../../domain/Ui/UiConstants';
import { getFirstActiveOrTrialOrganizationIdAndStatus } from '../../domain/Organization/OrganizationSelectors';
import { currentMessage } from '../legos/BannerService';

const mapStateToProps = (state: IRootState) => ({
  orgIdAndStatusToLink: getFirstActiveOrTrialOrganizationIdAndStatus(state),
});

type GoldenTicketSpecialBannerProps = ReturnType<typeof mapStateToProps> & RouteComponentProps;

const GoldenTicketSpecialBanner: React.FC<GoldenTicketSpecialBannerProps> = ({
  history,
  orgIdAndStatusToLink,
}) => {
  // todo: have the banner redirect to the correct purchase page
  // what's currently wrong with this is that the resulting page doesn't result in a purchase button
  const onClick = () => {
    const orgIdToLink = orgIdAndStatusToLink[0] || '';
    if (orgIdToLink) {
      history.push(urljoin(getRoute(routes.ORGANIZATION_PURCHASE_LICENSE.path, orgIdToLink), '/purchase?license=PRO&purchase=true'));
    } else {
      history.push(urljoin(routes.CREATE_ORGANIZATION.path, 'purchase?license=PRO&purchase=true'));
    }
  };

  const message = currentMessage('accountInfoBannerMessage');
  if (message) {
    return (
      <StatusMessage onClick={onClick}>
        {message}
      </StatusMessage>
    );
  }

  return <></>;
};

export default withRouter(connect(mapStateToProps)(GoldenTicketSpecialBanner));

